module.exports = __webpack_public_path__ + "img/icon-4.a3fefc99.svg";